export function getUndefinedIfEmpty<T>(
  value: string | string[] | Date | boolean | null | undefined,
): T | string | undefined {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    return value.toJSON() as T;
  }
  if (typeof value === 'boolean') {
    return String(value) as T;
  }

  if (Array.isArray(value)) {
    return value as T;
  }

  // if value is object
  if (typeof value === 'object') {
    return value;
  }

  return (value === undefined || value.trim() === '' ? undefined : value?.trim()) as T;
}
